import { DerivativeWallet } from "./derivative_wallet";
import { TYPE_NAME_STOCK } from "@helpers/constants";

export class StockWallet extends DerivativeWallet {
	public static TypeName: string = TYPE_NAME_STOCK;
}
